var iso8601DurationRegex =
	/(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/

export function parsePrepTime(iso8601Duration) {
	//if (iso8601Duration) {
	var matches = iso8601Duration.match(iso8601DurationRegex)
	return {
		years: matches[2] === undefined ? 0 : matches[2],
		months: matches[3] === undefined ? 0 : matches[3],
		weeks: matches[4] === undefined ? 0 : matches[4],
		days: matches[5] === undefined ? 0 : matches[5],
		hours: matches[6] === undefined ? 0 : matches[6],
		minutes: matches[7] === undefined ? 0 : matches[7],
		seconds: matches[8] === undefined ? 0 : matches[8],
	}
	// }
	// return {
	// 	years: 0,
	// 	months: 0,
	// 	weeks: 0,
	// 	days: 0,
	// 	hours: 0,
	// 	minutes: 0,
	// 	seconds: 0,
	// }
}

export function getPrepRange(restaurants) {
	var maxPrep = 0
	var minPrep = 9999
	var allPrepTimes = []
	restaurants.forEach(r => {
		allPrepTimes.push({
			id: r.id,
			prepTime: r.prepTime,
		})
		if (r.prepTime < minPrep) {
			minPrep = r.prepTime
		}
		if (r.prepTime > maxPrep) {
			maxPrep = r.prepTime
		}
	})
	return {
		min: minPrep,
		max: maxPrep,
		allPrepTimes: allPrepTimes,
	}
}

export function convertHours(hours, prepTime) {
	var hoursObj: any = {
		0: {},
		1: {},
		2: {},
		3: {},
		4: {},
		5: {},
		6: {},
	}
	Object.entries(hours).forEach(x => {
		var key: any = x[0]
		var obj: any = x[1]

		var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']

		var day = days.indexOf(key)

		var tempStart: any[] = []
		var tempEnd: any[] = []

		if (obj.length === 0) {
			// Consider empty object for the day as open 24 hours
			tempStart.push(0)
			tempEnd.push(24)
		} else {
			obj.forEach(o => {
				let endNum = parseFloat(o.end)
				let startNum = parseFloat(o.start)
				if (isNaN(startNum)) {
					startNum = 0
				}
				if (isNaN(endNum)) {
					endNum = 24
				}
				var end = minusPrepTime(endNum, prepTime)
				tempStart.push(startNum)
				tempEnd.push(endNum === 24 ? endNum : end)
			})
		}

		hoursObj[day] = { startTimes: tempStart, endTimes: tempEnd }
	})
	return hoursObj
}

//remove prep time from closing hour
//i.e. if restaurant closes at 8,
//show it closing at 7:45 (8 - prep time of 15 mins)
function minusPrepTime(endTime, prepMins) {
	if (endTime === 0) {
		return endTime
	} else {
		if (prepMins === 0) {
			return endTime
		} else {
			if (global.kiosk) {
				return endTime
			} else {
				return endTime - prepMins / 60 /* - 5 */ / 60 //extra 5 minutes so people aren't collecting orders right at close
			}
		}
	}
}
